import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AppForm from '../../components/AppForm';

export default function UserEdit() {
  return (
    <div style={{ margin: '2rem' }}>
      <AdminLayout  titleName='จัดการแอปพลิเคชัน'/>
      <Grid container style={{ marginTop: '4rem', marginBottom: '2rem' }}>
        <Grid item xs={12}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>แก้ไขแอปพลิเคชัน</Typography>
        </Grid>
        <Grid item xs={12} >
          <AppForm mode='edit' />
        </Grid>
      </Grid>
    </div>
  )
}